const $ = (selector, parent = document) => parent.querySelector(selector);
const $$ = (selector, parent = document) => parent.querySelectorAll(selector);

const observer = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.intersectionRatio > 0) {
      entry.target.classList.add('animate');
    }
    else {
      entry.target.classList.remove('animate');
    }
  })
})
const boxElList = $$(".cta-2-col");
boxElList.forEach((el) => {
  observer.observe(el);
})